import React, { useState } from 'react';
import styles from '../styles/deleteModal.module.css';
import { API_URL } from '../config/api';


const CustomDeleteModal = ({ onClose, products, onDeleted }) => {
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem('token'); // ✅ Берём токен

  const handleDelete = async () => {
    if (!token) {
      console.error('❌ Нет токена! Авторизация не выполнена.');
      alert('Вы не авторизованы!');
      return;
    }

    setLoading(true);
    try {
      for (const product of products) {
        console.log(`📤 Удаляем продукт id=${product.id}...`);

        const res = await fetch(`${API_URL}/api/products/${product.id}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`, // ✅ токен в заголовке
          },
        });

        console.log(`DELETE status для id=${product.id}:`, res.status);

        if (!res.ok) {
          const errData = await res.json().catch(() => null);
          console.error(`❌ Ошибка удаления id=${product.id}:`, errData || res.statusText);
          alert(`Не удалось удалить товар ${product.name} (id=${product.id})`);
        }
      }

      // 🔹 Обновляем родительский компонент
      if (onDeleted) {
        onDeleted(products.map(p => p.id));
      }

      // 🔹 Можно обновить localStorage, если хранили список продуктов
      const savedProducts = localStorage.getItem('products');
      if (savedProducts) {
        const updatedProducts = JSON.parse(savedProducts).filter(p => !products.some(d => d.id === p.id));
        localStorage.setItem('products', JSON.stringify(updatedProducts));
      }

      onClose();
    } catch (error) {
      console.error('💥 Ошибка при удалении товаров:', error);
      alert('Не удалось удалить товары');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <button className={styles.closeButton} onClick={onClose} disabled={loading}>
          ×
        </button>

        <div className={styles.attentionHead}>
          <span className={styles.attentionImg}></span>
          <h2 className={styles.title}>
            Удалить товар{products.length > 1 ? 'ы' : ''}?
          </h2>
        </div>

        <p className={styles.text}>
          Товар{products.length > 1 ? 'ы' : ''} буд{products.length > 1 ? 'у' : 'е'}т удалён{products.length > 1 ? 'ы' : ''}.
          <br />
          Это действие нельзя отменить.
        </p>

        <ul className={styles.productList}>
          {products.map((p) => (
            <li key={p.id} className={styles.productName}>
              {p.name} 
            </li>
          ))}
        </ul>

        <div className={styles.buttons}>
          <button className={styles.cancelButton} onClick={onClose} disabled={loading}>
            Отмена
          </button>
          <button className={styles.deleteButton} onClick={handleDelete} disabled={loading}>
            {loading ? 'Удаление...' : 'Удалить'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomDeleteModal;
